(function (w, d) { var loader = function () { var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src = "https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s, tag); }; if (w.addEventListener) { w.addEventListener("load", loader, false); } else if (w.attachEvent) { w.attachEvent("onload", loader); } else { w.onload = loader; } })(window, document);
var consense_marketing;
function onConsent(preference) {
    console.log('onConsent', preference);
    
    setTimeout(function () {
        if (preference.consent) {
            dataLayer.push({
                'event': 'cookie_law_accepted',
                'consense_marketing': true,
                'anonymizeIp': true
            });
        } else if (preference.purposes) {
            if (preference.purposes[5]) {
                dataLayer.push({
                    'event': 'cookie_law_accepted',
                    'consense_marketing': true,
                    'anonymizeIp': false
                });
            } else if (preference.purposes[4]) {
                dataLayer.push({
                    'event': 'cookie_law_accepted',
                    'consense_marketing': false,
                    'anonymizeIp': false
                });
            } else {
                dataLayer.push({
                    'event': 'cookie_law_accepted',
                    'consense_marketing': false,
                    'anonymizeIp': true
                });
            }


            if (preference.purposes[1]) {
                consense_marketing = false;
            }
            if (preference.purposes[2]) {
                consense_marketing = false;
            }
            if (preference.purposes[3]) {
                consense_marketing = false;
            }
            if (preference.purposes[4]) {
                consense_marketing = false;
            }
            if (preference.purposes[5]) {
                consense_marketing = true;
            }
        }
    }, 500);
}
